import gamevideojs from "./gamevideojs";
import Url from "domurl";
import "videojs-thumbnail-sprite";

export default class AppointmentPlayer {
  constructor(options = {}) {
    // Player
    this.player = null;
    this.editTime = false;
    this.programmaticSeek = false;

    this.options = Object.assign(
      {
        //customize and force custom options
      },
      options
    );

    // Times
    this.currentTime = 0;
    this.currentStartTime = 0;
    this.currentEndTime = 0;
    this.incrementDecrement = 1;
    this.incrementDecrementMinusPlus = 15;

    // Range Selector elements
    this.rangeSelector = null;
    this.rangeArea = null;
    this.handleStart = null;
    this.handleEnd = null;
    this.tooltipStart = null;
    this.tooltipEnd = null;
    this.isDragging = false;
    this.currentHandle = null;
    this.isDraggingArea = false;
    this.dragStartX = 0;
    this.dragStartTime = 0;
    this.dragStartTimeValue = 0;  // Store Time marker position at drag start
    this.clipDuration = 0;

    // Timeline crop for precision
    this.cropApplied = false;
    this.originalDuration = null;
    this.viewportStart = null;
    this.viewportEnd = null;
    this.customTimeDisplays = null; // Will hold references to custom display elements

    // Clip Preview
    this.previewPlayer = null;

    // Viewport adjustment constants and state
    this.VIEWPORT_MIN = 150;      // 2:30 in seconds (minimum viewport size)
    this.VIEWPORT_MAX = 600;      // 10:00 in seconds (maximum viewport size)
    this.VIEWPORT_INCREMENT = 30; // 30 seconds per click (15s each side)

    // Define elements
    this.defineElements();

    // Initialize a new gamevideojs
    if ($("#appointment-player").length > 0) {
      this.player = gamevideojs("#appointment-player", this.options);

      // Added video sprites/frames images
      let frames = $("#appointment-player").data("frames");
      let sprites = []
      let frameStart = 0;

      frames.forEach(frame => {
        sprites.push({
          url: frame,
          start: frameStart,
          duration: 320,
          width: 160,
          height: 90,
          interval: 2,
        });
  
        frameStart = frameStart + 320;
      });

      this.player.thumbnailSprite({
        sprites: sprites
      });

      // Enforce force mute for club users
      this.enforceForceMute();

      // Update player time
      this.player.on("timeupdate", () => {
        this.updateTimes();
      });

      // Update clip fields when user clicks on video timeline
      this.player.on("seeked", () => {

        // Reset programmaticSeek flag at the start of the event
        // This ensures it's reset even if we return early
        const wasProgrammaticSeek = this.programmaticSeek;
        this.programmaticSeek = false;

        if ($("#create-clip-form").is(":visible") && !wasProgrammaticSeek) {
          let currentTime = this.player.currentTime();

          // If crop is applied, we need to convert relative time to absolute
          if (this.cropApplied && this.viewportStart) {
            currentTime = currentTime + this.viewportStart;
          }

          let clipStartTime = Math.max(0, currentTime - this.incrementDecrementMinusPlus);
          let clipEndTime = currentTime + this.incrementDecrementMinusPlus;

          // Update clip time fields
          $(".clip_start_time").val(clipStartTime);
          $(".clip_time").val(currentTime);
          $(".clip_end_time").val(clipEndTime);

          // Update clip display values
          $(".clip-start-time").html(
            this.player.gamevideojs.returnFormattedDataMatch(clipStartTime)
          );
          $(".clip-time").html(
            this.player.gamevideojs.returnFormattedDataMatch(currentTime)
          );
          $(".clip-end-time").html(
            this.player.gamevideojs.returnFormattedDataMatch(clipEndTime)
          );

          // Update formatted hidden fields
          $(".edit_clip_start_time").val(
            this.player.gamevideojs.returnFormattedDataMatch(clipStartTime)
          );
          $(".edit_clip_time").val(
            this.player.gamevideojs.returnFormattedDataMatch(currentTime)
          );
          $(".edit_clip_end_time").val(
            this.player.gamevideojs.returnFormattedDataMatch(clipEndTime)
          );
        }

        // Reset the flag after handling the seek
        this.programmaticSeek = false;
      });

      // Initialize Jump to Time feature (works on main player, not during clip creation)
      this.initializeJumpToTime();
    }
  }

  defineElements() {
    // Spans
    this.observationEventTime = $(".observation-event-time");
    this.observationEventStartTime = $(".observation-event-start-time");
    this.observationEventEndTime = $(".observation-event-end-time");

    // Fields
    this.observationEventTimeField = $(".observation_event_time");
    this.observationEventStartTimeField = $(".observation_event_start_time");
    this.observationEventEndTimeField = $(".observation_event_end_time");

    // Edit times
    this.observationEditEventTimeField = $(".observation_edit_event_time");
    this.observationEditEventStartTimeField = $(
      ".observation_edit_event_start_time"
    );
    this.observationEditEventEndTimeField = $(
      ".observation_edit_event_end_time"
    );

    // Actions buttons minus and plus
    this.btnMinusEventTime = $(".btn-minus-event-time");
    this.btnPlusEventTime = $(".btn-plus-event-time");
    this.btnMinusEventStartTime = $(".btn-minus-event-start-time");
    this.btnPlusEventStartTime = $(".btn-plus-event-start-time");
    this.btnMinusEventEndTime = $(".btn-minus-event-end-time");
    this.btnPlusEventEndTime = $(".btn-plus-event-end-time");
    this.btnCancelKmi = $(".btn-cancel-kmi");

    this.btnMinusClipStartTime = $(".btn-minus-clip-start-time");
    this.btnPlusClipStartTime = $(".btn-plus-clip-start-time");
    this.btnMinusClipTime = $(".btn-minus-clip-time");
    this.btnPlusClipTime = $(".btn-plus-clip-time");
    this.btnMinusClipEndTime = $(".btn-minus-clip-end-time");
    this.btnPlusClipEndTime = $(".btn-plus-clip-end-time");

    // Camera angle links
    this.cameraAngleLinks = $(".camera-angle-link");

    // Cancel btns
    this.btnCancelCompetency = $("#btn-cancel-competency");
    this.btnCancelKeyIncident = $("#btn-cancel-kmi");
    this.btnCancelKeyIncidentCaution = $("#btn-cancel-kmi-caution");

    // Add behaviours
    this.btnBehaviours();
    this.createClipBehaviour();
  }

  btnBehaviours() {
    let scope = this;

    this.btnMinusEventTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnMinusEventStartTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventStartTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnMinusEventEndTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnPlusEventEndTime.on("click", function (event) {
      scope.clickBtnTimer(this, event);
    });

    this.btnMinusClipStartTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });
    this.btnPlusClipStartTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });
    this.btnMinusClipTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });
    this.btnPlusClipTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });
    this.btnMinusClipEndTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });
    this.btnPlusClipEndTime.on("click", function (event) {
      scope.clickBtnClipTimer(this, event);
    });

    this.btnCancelCompetency.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingOne").find("button").click();
    });

    this.btnCancelKeyIncident.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingFour").find("button").click();
    });

    this.btnCancelKeyIncidentCaution.on("click", function (event) {
      event.preventDefault();
      $("#flush-headingFive").find("button").click();
    });
  }

  clickBtnTimer(element, event) {
    event.preventDefault();
    this.editTime = true;

    this.pausePlayer();

    let action = $(element).data("action");
    let updateField = $($(element).data("update-field"));
    let updateView = $($(element).data("update-view"));
    let type = $(element).data("type");

    if (action == "minus") {
      this.decrementTimer(type, updateField, updateView);
    } else {
      this.incrementTimer(type, updateField, updateView);
    }
  }

  clickBtnClipTimer(element, event) {
    event.preventDefault();
    this.pausePlayer();

    let action = $(element).data("action");
    let updateField = $($(element).data("update-field"));
    let updateView = $($(element).data("update-view"));
    let type = $(element).data("type");

    this.incrementOrDecrementClipTimer(action, type, updateField, updateView);
  }

  pausePlayer() {
    if (this.player) {
      this.player.pause();
    }
  }

  dispose() {
    if (this.player != null) {
      this.player.dispose();
    }
  }

  incrementTimer(type, updateField, updateView) {
    this.incrementOrDecrementTimer("plus", type, updateField, updateView);
  }

  decrementTimer(type, updateField, updateView) {
    this.incrementOrDecrementTimer("minus", type, updateField, updateView);
  }

  incrementOrDecrementTimer(action, type, updateField, updateView) {
    let currentVal = parseFloat(updateField.val());
    let newValue = currentVal;
    let increment_action =
      type == "time"
        ? this.incrementDecrement
        : this.incrementDecrementMinusPlus;

    if (action == "minus") {
      newValue = currentVal - increment_action;
    } else {
      newValue = currentVal + increment_action;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    if (type == "time") {
      this.currentTime = newValue;

      // Start time
      if (this.currentStartTime >= this.currentTime) {
        this.currentStartTime =
          this.currentTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentStartTime,
          this.observationEventStartTimeField,
          this.observationEventStartTime
        );
      }

      // End time
      if (this.currentEndTime <= this.currentTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }
    } else if (type == "start") {
      this.currentStartTime = newValue;

      // Current time
      if (this.currentStartTime >= this.currentTime) {
        this.currentTime =
          this.currentStartTime + this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          this.currentTime,
          this.observationEventTimeField,
          this.observationEventTime
        );
      }

      // End time
      if (this.currentEndTime <= this.currentStartTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }

      // End time
      if (this.currentTime == this.currentEndTime) {
        this.currentEndTime =
          this.currentTime + this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentEndTime,
          this.observationEventEndTimeField,
          this.observationEventEndTime
        );
      }
    } else if (type == "end") {
      this.currentEndTime = newValue;

      // Current time
      if (this.currentEndTime == this.currentTime) {
        this.currentTime =
          this.currentEndTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentTime,
          this.observationEventTimeField,
          this.observationEventTime
        );
      }

      // Start time
      if (this.currentStartTime >= this.currentTime) {
        this.currentStartTime =
          this.currentTime - this.incrementDecrementMinusPlus;

        this.updateTimerWithValue(
          this.currentStartTime,
          this.observationEventStartTimeField,
          this.observationEventStartTime
        );
      }
    }

    if (this.currentTime < 0) {
      this.currentTime = 0;
    }

    if (this.currentStartTime < 0) {
      this.currentStartTime = 0;
    }

    if (this.currentEndTime < 0) {
      this.currentEndTime = 0;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    this.programmaticSeek = true;
    this.player.currentTime(this.currentTime);
    this.updateTimerWithValue(newValue, updateField, updateView);
  }

  incrementOrDecrementClipTimer(action, type, updateField, updateView) {
    let currentVal = parseFloat(updateField.val());
    let newValue = currentVal;
    let increment_action =
      type == "time"
        ? this.incrementDecrement
        : this.incrementDecrementMinusPlus;

    if (action == "minus") {
      newValue = currentVal - increment_action;
    } else {
      newValue = currentVal + increment_action;
    }

    if (newValue < 0) {
      newValue = 0;
    }

    let clipStartTimeField = $(".clip_start_time");
    let clipTimeField = $(".clip_time");
    let clipEndTimeField = $(".clip_end_time");

    let clipStartTimeView = $(".clip-start-time");
    let clipTimeView = $(".clip-time");
    let clipEndTimeView = $(".clip-end-time");
    
    // Edit fields for formatted values
    let editClipStartTimeField = $(".edit_clip_start_time");
    let editClipTimeField = $(".edit_clip_time");
    let editClipEndTimeField = $(".edit_clip_end_time");

    let clipStartTime = parseFloat(clipStartTimeField.val());
    let clipTime = parseFloat(clipTimeField.val());
    let clipEndTime = parseFloat(clipEndTimeField.val());

    if (type == "time") {
      clipTime = newValue;
      if (clipStartTime >= clipTime) {
        clipStartTime = clipTime - this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          clipStartTime,
          clipStartTimeField,
          clipStartTimeView
        );
        // Update formatted value (convert to absolute if crop is applied)
        let displayStartTime = clipStartTime;
        if (this.cropApplied && this.viewportStart) {
          displayStartTime = clipStartTime + this.viewportStart;
        }
        editClipStartTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));
      }
      if (clipEndTime <= clipTime) {
        clipEndTime = clipTime + this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          clipEndTime,
          clipEndTimeField,
          clipEndTimeView
        );
        // Update formatted value (convert to absolute if crop is applied)
        let displayEndTime = clipEndTime;
        if (this.cropApplied && this.viewportStart) {
          displayEndTime = clipEndTime + this.viewportStart;
        }
        editClipEndTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));
      }
    } else if (type == "start") {
      clipStartTime = newValue;
      if (clipStartTime >= clipTime) {
        clipTime = clipStartTime + this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(clipTime, clipTimeField, clipTimeView);
        // Update formatted value (convert to absolute if crop is applied)
        let displayTime = clipTime;
        if (this.cropApplied && this.viewportStart) {
          displayTime = clipTime + this.viewportStart;
        }
        editClipTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayTime));
      }
      if (clipEndTime <= clipStartTime) {
        clipEndTime = clipTime + this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          clipEndTime,
          clipEndTimeField,
          clipEndTimeView
        );
        // Update formatted value (convert to absolute if crop is applied)
        let displayEndTime = clipEndTime;
        if (this.cropApplied && this.viewportStart) {
          displayEndTime = clipEndTime + this.viewportStart;
        }
        editClipEndTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));
      }
    } else if (type == "end") {
      clipEndTime = newValue;
      if (clipEndTime <= clipTime) {
        clipTime = clipEndTime - this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(clipTime, clipTimeField, clipTimeView);
        // Update formatted value (convert to absolute if crop is applied)
        let displayTime = clipTime;
        if (this.cropApplied && this.viewportStart) {
          displayTime = clipTime + this.viewportStart;
        }
        editClipTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayTime));
      }
      if (clipStartTime >= clipTime) {
        clipStartTime = clipTime - this.incrementDecrementMinusPlus;
        this.updateTimerWithValue(
          clipStartTime,
          clipStartTimeField,
          clipStartTimeView
        );
        // Update formatted value (convert to absolute if crop is applied)
        let displayStartTime = clipStartTime;
        if (this.cropApplied && this.viewportStart) {
          displayStartTime = clipStartTime + this.viewportStart;
        }
        editClipStartTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));
      }
    }

    if (clipTime < 0) clipTime = 0;
    if (clipStartTime < 0) clipStartTime = 0;
    if (clipEndTime < 0) clipEndTime = 0;
    if (newValue < 0) newValue = 0;

    this.programmaticSeek = true;
    this.player.currentTime(clipTime);
    this.updateTimerWithValue(newValue, updateField, updateView);

    // Update the formatted value for the field being edited
    // If crop is applied, convert relative time to absolute for display
    let displayValue = newValue;
    if (this.cropApplied && this.viewportStart) {
      displayValue = newValue + this.viewportStart;
    }
    let formattedValue = this.player.gamevideojs.returnFormattedDataMatch(displayValue);
    if (type == "time") {
      editClipTimeField.val(formattedValue);
    } else if (type == "start") {
      editClipStartTimeField.val(formattedValue);
    } else if (type == "end") {
      editClipEndTimeField.val(formattedValue);
    }

    // Update range selector visual position if it exists
    if (this.rangeSelector) {
      this.updateRangeSelectorPosition();
    }
  }

  updateTimerWithValue(newValue, updateField, updateView) {
    let minutesAndSeconds = this.calcMinutesAndSeconds(newValue);
    // let formatedMinutesAndSeconds = this.formatHourMinute(
    //   minutesAndSeconds[0],
    //   minutesAndSeconds[1]
    // );
    updateField.val(newValue);

    // If crop is applied, convert relative time to absolute for display
    let displayValue = newValue;
    if (this.cropApplied && this.viewportStart) {
      displayValue = newValue + this.viewportStart;
    }

    updateView.html(
      this.player.gamevideojs.returnFormattedDataMatch(displayValue)
    );
  }

  enforceForceMute() {
    const playerElement = document.getElementById('appointment-player');
    if (!playerElement) return;

    const forceMute = playerElement.getAttribute('data-force-mute') === 'true';

    if (forceMute && this.player) {
      // Force mute and set volume to 0
      this.player.muted(true);
      this.player.volume(0);

      // Hide volume controls
      const volumePanel = this.player.controlBar.volumePanel;
      if (volumePanel) {
        volumePanel.hide();
      }

      // Prevent unmuting via events
      this.player.on('volumechange', () => {
        if (!this.player.muted() || this.player.volume() > 0) {
          this.player.muted(true);
          this.player.volume(0);
        }
      });

      // Add CSS class to hide controls
      playerElement.classList.add('force-muted-player');
    }
  }

  updateTimes() {
    this.currentTime = this.player.currentTime();
    //this.currentTime = this.player.gamevideojs.getCurrentRealTime();

    if (!this.editTime) {
      this.currentStartTime =
        this.currentTime - this.incrementDecrementMinusPlus;
      this.currentEndTime = this.currentTime + this.incrementDecrementMinusPlus;
    }

    if (this.currentStartTime < 0) {
      this.currentStartTime = 0;
    }

    // Update divs
    this.observationEventTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentTime)
      )
    );
    this.observationEventStartTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentStartTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentStartTime)
      )
    );
    this.observationEventEndTime.html(
      this.player.gamevideojs.returnFormattedDataMatch(
        this.currentEndTime
        //this.player.gamevideojs.getMatchTimeByRealTime(this.currentEndTime)
      )
    );

    // Update fields values
    this.observationEventTimeField.val(this.currentTime);
    this.observationEventStartTimeField.val(this.currentStartTime);
    this.observationEventEndTimeField.val(this.currentEndTime);

    // Update edit fields values
    this.observationEditEventTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentTime)
    );
    this.observationEditEventStartTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentStartTime)
    );
    this.observationEditEventEndTimeField.val(
      this.player.gamevideojs.returnFormattedDataMatch(this.currentEndTime)
    );

    // Update camera angle links
    this.updateCameraAngleLinks();
  }

  updateCameraAngleLinks() {
    let scope = this;

    this.cameraAngleLinks.each(function () {
      let href = $(this).attr("href");

      let url = new Url(href);
      url.query.event_start_time = scope.player.currentTime();

      $(this).attr("href", url.toString());
    });
  }

  calcMinutesAndSeconds(currentTime) {
    if (currentTime > 0) {
      let minutes = Math.floor(currentTime / 60);
      let seconds = Math.floor(currentTime - minutes * 60);

      return [minutes, seconds];
    } else {
      return [0, 0];
    }
  }

  formatHourMinute(minutes, seconds) {
    let x = minutes < 10 ? "0" + minutes : minutes;
    let y = seconds < 10 ? "0" + seconds : seconds;

    return x + ":" + y;
  }

  /**
   * Apply crop to timeline to show only 150s viewport (75s before and after current time)
   * This enables precision of 1 second when adjusting handles
   */
  applyCropToTimeline() {
    if (!this.player || !this.player.gamevideojs) {
      return;
    }

    // Check if video already has a crop (match start/end time)
    const originalStartCrop = this.player.gamevideojs.startCrop;
    const originalEndCrop = this.player.gamevideojs.endCrop;
    const cropMatch = this.player.gamevideojs.cropMatch;

    // IMPORTANT: Read firstMatchStartTime from options directly, not from the instance variable
    // because the instance variable might be set to false/0 if no crop was explicitly set via setCrop
    const firstMatchStartTime = this.player.gamevideojs.options.firstMatchStartTime
      ? parseFloat(this.player.gamevideojs.options.firstMatchStartTime)
      : 0;

    // Get current time - this is relative to any existing crop
    // We will NOT adjust it here - the offset will be added later when calling setCrop
    const currentTime = this.player.currentTime();
    const duration = this.player.duration();

    const viewportBuffer = 75; // 75s before and 75s after
    const minViewportDuration = 150; // Minimum 150s viewport

    // Store original duration before applying crop
    this.originalDuration = duration;

    // Don't apply crop if video is shorter than viewport duration
    if (duration < minViewportDuration) {
      return;
    }

    // Calculate viewport based on current (relative) time
    let viewportStart = currentTime - viewportBuffer;
    let viewportEnd = currentTime + viewportBuffer;

    // Adjust if near start of video
    if (viewportStart < 0) {
      viewportStart = 0;
      viewportEnd = Math.min(duration, minViewportDuration);
    }

    // Adjust if near end of video
    if (viewportEnd > duration) {
      viewportEnd = duration;
      viewportStart = Math.max(0, duration - minViewportDuration);
    }

    // Store viewport offsets for later use (WITHOUT crop offset, as these are used for relative calculations)
    this.viewportStart = viewportStart;
    this.viewportEnd = viewportEnd;

    // IMPORTANT: If video has cropMatch active with firstMatchStartTime, we need to add it
    // to the viewport values because setCrop expects ABSOLUTE times relative to the original video
    const cropOffset = (cropMatch && firstMatchStartTime) ? firstMatchStartTime : 0;
    const absoluteViewportStart = viewportStart + cropOffset;
    const absoluteViewportEnd = viewportEnd + cropOffset;

    // Apply crop using gamevideojs setCrop method
    this.player.gamevideojs.setCrop(absoluteViewportStart, absoluteViewportEnd);
    this.cropApplied = true;

    // IMPORTANT: The videojs-offset plugin DOES NOT preserve the player position!
    // After applying setCrop, the player jumps to an incorrect position.
    // We MUST manually reposition it to the correct relative time within the NEW viewport.
    // Since we calculated viewport based on currentTime, the expected position is simply currentTime - viewportStart
    const expectedRelativeTime = currentTime - viewportStart;

    this.programmaticSeek = true; // Prevent "seeked" event from interfering
    this.player.currentTime(expectedRelativeTime);

    // Create custom time displays to show absolute times (native displays will be hidden via CSS)
    this.createCustomTimeDisplays();

    // Convert clip times to relative values (relative to viewport)
    this.convertClipTimesToRelative();
  }

  /**
   * Create custom time displays to show absolute times (instead of fighting with native displays)
   */
  createCustomTimeDisplays() {
    if (!this.player || !this.player.gamevideojs) {
      return;
    }

    // Find the time display container
    const timeDisplayContainer = this.player.gamevideojs.selectorElement.querySelector('.gamevideojs-control-display-time');
    if (!timeDisplayContainer) {
      return;
    }

    // Create custom current time display
    const customCurrentTime = document.createElement('div');
    customCurrentTime.className = 'clip-custom-time-display-current';

    // Create custom duration display
    const customDuration = document.createElement('div');
    customDuration.className = 'clip-custom-time-display-total';

    // Insert custom displays into container
    timeDisplayContainer.appendChild(customCurrentTime);
    timeDisplayContainer.appendChild(customDuration);

    // Store references
    this.customTimeDisplays = {
      current: customCurrentTime,
      duration: customDuration,
      container: timeDisplayContainer
    };

    // Update displays immediately with current values
    this.updateCustomTimeDisplays();

    // Listen to player timeupdate event to keep displays in sync
    const scope = this;
    this.customTimeDisplays.updateListener = function() {
      scope.updateCustomTimeDisplays();
    };
    this.player.on('timeupdate', this.customTimeDisplays.updateListener);
  }

  /**
   * Update custom time displays with absolute times
   */
  updateCustomTimeDisplays() {
    if (!this.customTimeDisplays || !this.cropApplied || !this.player) {
      return;
    }

    const relativeTime = this.player.currentTime();
    const absoluteTime = relativeTime + this.viewportStart;

    // Update current time
    const formattedTime = this.player.gamevideojs.returnFormattedDataMatch(absoluteTime);
    this.customTimeDisplays.current.innerHTML = formattedTime;

    // Update duration
    const formattedDuration = this.player.gamevideojs.returnFormattedDataMatch(this.originalDuration);
    this.customTimeDisplays.duration.innerHTML = formattedDuration;
  }

  /**
   * Remove custom time displays and restore native displays
   */
  removeCustomTimeDisplays() {
    if (!this.customTimeDisplays) {
      return;
    }

    // Remove timeupdate listener
    if (this.customTimeDisplays.updateListener && this.player) {
      this.player.off('timeupdate', this.customTimeDisplays.updateListener);
    }

    // Remove custom display elements from DOM
    if (this.customTimeDisplays.current && this.customTimeDisplays.current.parentNode) {
      this.customTimeDisplays.current.parentNode.removeChild(this.customTimeDisplays.current);
    }
    if (this.customTimeDisplays.duration && this.customTimeDisplays.duration.parentNode) {
      this.customTimeDisplays.duration.parentNode.removeChild(this.customTimeDisplays.duration);
    }

    // Clear references
    this.customTimeDisplays = null;
  }

  /**
   * Convert absolute clip times to relative times (relative to viewport start)
   * This is necessary because after crop, player.duration() returns viewport duration
   */
  convertClipTimesToRelative() {
    if (!this.cropApplied || !this.viewportStart) {
      return;
    }

    // Get absolute values from fields
    const absoluteStartTime = parseFloat($(".clip_start_time").val());
    const absoluteTime = parseFloat($(".clip_time").val());
    const absoluteEndTime = parseFloat($(".clip_end_time").val());

    // Store absolute values for display purposes
    this.absoluteStartTime = absoluteStartTime;
    this.absoluteTime = absoluteTime;
    this.absoluteEndTime = absoluteEndTime;

    // Convert to relative (subtract viewport start)
    const relativeStartTime = absoluteStartTime - this.viewportStart;
    const relativeTime = absoluteTime - this.viewportStart;
    const relativeEndTime = absoluteEndTime - this.viewportStart;

    // Update hidden fields with relative values (for range selector)
    $(".clip_start_time").val(relativeStartTime);
    $(".clip_time").val(relativeTime);
    $(".clip_end_time").val(relativeEndTime);
    // Update displays to show absolute values (not relative!)
    this.updateTimeDisplaysWithAbsoluteValues();

    // Force update range selector position with new relative values
    if (this.rangeSelector) {
      this.updateRangeSelectorPosition();
    }

    // Force update again after a small delay to ensure it's not overwritten
    setTimeout(() => {
      this.updateTimeDisplaysWithAbsoluteValues();
      // Also update range selector position again
      if (this.rangeSelector) {
        this.updateRangeSelectorPosition();
      }
    }, 100);
  }

  /**
   * Update time displays to show absolute values (original video time)
   * This is necessary because after crop, we need to show real video time, not relative time
   */
  updateTimeDisplaysWithAbsoluteValues() {
    if (!this.cropApplied) {
      return;
    }

    const formattedStart = this.player.gamevideojs.returnFormattedDataMatch(this.absoluteStartTime);
    const formattedTime = this.player.gamevideojs.returnFormattedDataMatch(this.absoluteTime);
    const formattedEnd = this.player.gamevideojs.returnFormattedDataMatch(this.absoluteEndTime);

    // Use stored absolute values for display
    $(".clip-start-time").html(formattedStart);
    $(".clip-time").html(formattedTime);
    $(".clip-end-time").html(formattedEnd);

    // Update formatted hidden fields if they exist
    if ($(".edit_clip_start_time").length > 0) {
      $(".edit_clip_start_time").val(formattedStart);
    }
    if ($(".edit_clip_time").length > 0) {
      $(".edit_clip_time").val(formattedTime);
    }
    if ($(".edit_clip_end_time").length > 0) {
      $(".edit_clip_end_time").val(formattedEnd);
    }
  }

  /**
   * Convert relative clip times back to absolute times (add viewport start)
   * Call this before saving to restore absolute values
   */
  convertClipTimesToAbsolute() {
    if (!this.cropApplied || !this.viewportStart) {
      return;
    }

    // Get relative values from fields
    const relativeStartTime = parseFloat($(".clip_start_time").val());
    const relativeTime = parseFloat($(".clip_time").val());
    const relativeEndTime = parseFloat($(".clip_end_time").val());

    // Convert to absolute (add viewport start)
    const absoluteStartTime = relativeStartTime + this.viewportStart;
    const absoluteTime = relativeTime + this.viewportStart;
    const absoluteEndTime = relativeEndTime + this.viewportStart;

    // Update fields with absolute values
    $(".clip_start_time").val(absoluteStartTime);
    $(".clip_time").val(absoluteTime);
    $(".clip_end_time").val(absoluteEndTime);

  }

  /**
   * Remove crop from timeline to show full video
   */
  removeCropFromTimeline() {
    if (!this.player || !this.player.gamevideojs || !this.cropApplied) {
      return;
    }

    // Remove custom time displays (native displays will be shown again via CSS)
    this.removeCustomTimeDisplays();

    // Convert times back to absolute before removing crop
    this.convertClipTimesToAbsolute();

    // Use stored original duration or get it from player if not available
    const duration = this.originalDuration || this.player.duration();

    // Reset crop to show full video
    this.player.gamevideojs.setCrop(0, duration);
    this.cropApplied = false;
    this.originalDuration = null;
    this.viewportStart = null;
    this.viewportEnd = null;

  }

  createClipBehaviour() {
    let scope = this;

    $("#btn-create-clip").on("click", function(event) {
      event.preventDefault();

      // IMPORTANT: Capture current time BEFORE pausing!
      // If we pause first, there's a race condition where the video continues playing
      // for a few milliseconds while the pause command is processed, causing the time
      // to drift and the crop to be applied to the wrong position.

      // Get ABSOLUTE current time (before any crop might be applied)
      // If crop was previously applied, we need to add viewportStart back
      let currentTime = scope.player.currentTime();

      if (scope.cropApplied && scope.viewportStart) {
        currentTime = currentTime + scope.viewportStart;
      }

      // NOW pause the player AFTER capturing the time
      scope.pausePlayer();

      let startTime = Math.max(0, currentTime - 15);
      let endTime = currentTime + 15;

      $(".clip_start_time").val(startTime);
      $(".clip_time").val(currentTime);
      $(".clip_end_time").val(endTime);

      // Update display values
      $(".clip-start-time").html(
        scope.player.gamevideojs.returnFormattedDataMatch(startTime)
      );
      $(".clip-time").html(
        scope.player.gamevideojs.returnFormattedDataMatch(currentTime)
      );
      $(".clip-end-time").html(
        scope.player.gamevideojs.returnFormattedDataMatch(endTime)
      );

      // Update formatted hidden fields (only if they exist)
      if ($(".edit_clip_start_time").length > 0) {
        $(".edit_clip_start_time").val(
          scope.player.gamevideojs.returnFormattedDataMatch(startTime)
        );
      }
      if ($(".edit_clip_time").length > 0) {
        $(".edit_clip_time").val(
          scope.player.gamevideojs.returnFormattedDataMatch(currentTime)
        );
      }
      if ($(".edit_clip_end_time").length > 0) {
        $(".edit_clip_end_time").val(
          scope.player.gamevideojs.returnFormattedDataMatch(endTime)
        );
      }

      $(".match-preview-container-list").hide();
      $("#create-clip-form").show();

      // Hide the Create Clip button and show Preview button
      $("#btn-create-clip").hide();
      $("#btn-preview-clip").show();

      // Hide Jump to Time field during clip creation
      $(".jump-to-time-wrapper").attr("style", "display: none !important");

      let tempSelectMatchIncident = document.getElementById('observation_clip_official_ids');
      if (tempSelectMatchIncident && tempSelectMatchIncident.tomselect) {
        tempSelectMatchIncident.tomselect.clear();
      }

      // Apply crop to timeline for precision (150s viewport)
      scope.applyCropToTimeline();

      // Initialize range selector
      scope.initializeRangeSelector();

      // Initialize clip preview button
      scope.initializeClipPreviewButton();

      // Show and initialize viewport adjustment buttons
      $("#viewport-controls").show();
      scope.initializeViewportButtons();
    });

    // Add listener to cancel button to destroy range selector and remove crop
    $("#btn-cancel-clip").on("click", function() {
      scope.destroyRangeSelector();
      scope.removeCropFromTimeline();
      $("#btn-create-clip").show();
      $("#btn-preview-clip").hide();
      $("#viewport-controls").hide();
      // Show Jump to Time field again
      $(".jump-to-time-wrapper").removeAttr("style");
    });

    // Add listener to form submit BEFORE to convert times back to absolute
    $("#create-clip-form").on("ajax:before", function() {
      scope.convertClipTimesToAbsolute();
    });

    // Add listener to form submit success to destroy range selector and remove crop
    $("#create-clip-form").on("ajax:success", function() {
      scope.destroyRangeSelector();
      scope.removeCropFromTimeline();
      $("#btn-create-clip").show();
      $("#btn-preview-clip").hide();
      $("#viewport-controls").hide();
      // Show Jump to Time field again
      $(".jump-to-time-wrapper").removeAttr("style");
    });

    // Add listener to form submit error to show Jump to Time field again
    $("#create-clip-form").on("ajax:error", function() {
      // Show Jump to Time field again even if there's an error
      $(".jump-to-time-wrapper").removeAttr("style");
    });

    // Initialize editable time fields
    scope.initializeEditableTimeFields();
  }

  initializeEditableTimeFields() {
    const scope = this;

    // Make time display fields editable
    const fields = [
      { display: '.clip-start-time', hidden: '.clip_start_time', edit: '.edit_clip_start_time', type: 'start' },
      { display: '.clip-time', hidden: '.clip_time', edit: '.edit_clip_time', type: 'time' },
      { display: '.clip-end-time', hidden: '.clip_end_time', edit: '.edit_clip_end_time', type: 'end' }
    ];

    fields.forEach(field => {
      const displayElement = $(field.display);

      // Make contenteditable
      displayElement.attr('contenteditable', 'true');
      displayElement.attr('spellcheck', 'false');
      displayElement.css({
        'cursor': 'text',
        'padding': '2px 4px',
        'border-radius': '3px',
        'transition': 'background-color 0.2s'
      });

      // Visual feedback on focus
      displayElement.on('focus', function() {
        $(this).css('background-color', 'rgba(255, 255, 255, 0.1)');
        // Select all text
        scope.selectAllText(this);
        // Store original value for revert on Escape and for change detection
        $(this).data('original-value', $(this).text());
        $(this).data('original-seconds', $(field.hidden).val());
      });

      displayElement.on('blur', function() {
        $(this).css('background-color', 'transparent');
      });

      // Handle Enter key (save) and Escape (cancel)
      displayElement.on('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          $(this).blur();
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          const originalValue = $(this).data('original-value');
          $(this).text(originalValue);
          $(this).blur();
        }
        // Prevent non-numeric characters except : and +
        if (e.key.length === 1 && !/[\d:+]/.test(e.key)) {
          e.preventDefault();
        }
      });

      // Apply mask during typing
      displayElement.on('input', function() {
        scope.applyTimeMask(this);
      });

      // Handle paste
      displayElement.on('paste', function(e) {
        e.preventDefault();
        const text = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
        const cleaned = text.replace(/[^\d:+]/g, '');
        document.execCommand('insertText', false, cleaned);
      });

      // Validate and update on blur
      displayElement.on('blur', function() {
        const value = $(this).text().trim();
        const originalSeconds = $(this).data('original-seconds');
        scope.handleTimeFieldChange(value, field, originalSeconds);
      });
    });
  }

  selectAllText(element) {
    const range = document.createRange();
    range.selectNodeContents(element);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  applyTimeMask(element) {
    // Get current text and cursor position
    const selection = window.getSelection();
    const cursorOffset = selection.anchorOffset;
    const currentText = element.textContent;

    // Count how many digits are before the cursor
    let digitsBeforeCursor = 0;
    let plusBeforeCursor = false;
    for (let i = 0; i < cursorOffset && i < currentText.length; i++) {
      if (/\d/.test(currentText[i])) {
        digitsBeforeCursor++;
      }
      if (currentText[i] === '+') {
        plusBeforeCursor = true;
      }
    }

    // Get only text content, remove any formatting
    let text = element.textContent.replace(/[^\d+]/g, '');

    if (text.length === 0) {
      return;
    }

    // Check if has + (additional time)
    const hasPlus = text.includes('+');

    let formatted;
    if (hasPlus) {
      // Format: MM:SS+MM:SS
      const parts = text.split('+');
      let mainPart = parts[0] || '';
      let additionalPart = parts[1] || '';

      // Format main part (MM:SS)
      mainPart = this.formatTimePart(mainPart);

      // Format additional part (MM:SS)
      additionalPart = this.formatTimePart(additionalPart);

      // Combine
      formatted = additionalPart ? mainPart + '+' + additionalPart : mainPart + '+';
    } else {
      // Format: MM:SS
      formatted = this.formatTimePart(text);
    }

    // Update element
    element.textContent = formatted;

    // Calculate new cursor position based on digits before cursor
    let newCursorPosition = 0;
    let digitsCount = 0;
    let foundPlus = false;

    for (let i = 0; i < formatted.length; i++) {
      // If we were after the + before, make sure we're after it now
      if (formatted[i] === '+') {
        foundPlus = true;
        if (plusBeforeCursor && digitsCount < digitsBeforeCursor) {
          newCursorPosition = i + 1;
          continue;
        }
      }

      if (/\d/.test(formatted[i])) {
        digitsCount++;
        if (digitsCount >= digitsBeforeCursor) {
          newCursorPosition = i + 1;
          break;
        }
      }
    }

    // If we didn't find enough digits, place at end
    if (newCursorPosition === 0 || digitsCount < digitsBeforeCursor) {
      newCursorPosition = formatted.length;
    }

    // Restore cursor position
    const range = document.createRange();
    const sel = window.getSelection();

    if (element.firstChild) {
      range.setStart(element.firstChild, Math.min(newCursorPosition, element.firstChild.length));
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  formatTimePart(digits) {
    // Remove any non-digits
    digits = digits.replace(/\D/g, '');

    if (digits.length === 0) {
      return '';
    }

    if (digits.length === 1) {
      return digits;
    } else if (digits.length === 2) {
      return digits;
    } else if (digits.length === 3) {
      // ABC -> AB:C
      return digits.substring(0, 2) + ':' + digits.substring(2);
    } else {
      // ABCD+ -> AB:CD
      return digits.substring(0, 2) + ':' + digits.substring(2, 4);
    }
  }

  parseTimeString(timeString) {
    // Parse formats: "MM:SS" or "MM:SS+MM:SS"
    timeString = timeString.trim();

    // Check if has additional time (+)
    const parts = timeString.split('+');

    if (parts.length > 2) {
      return null; // Invalid format
    }

    let totalSeconds = 0;

    // Parse main time
    const mainTime = parts[0].trim();
    const mainParts = mainTime.split(':');

    if (mainParts.length !== 2) {
      return null; // Invalid format
    }

    const minutes = parseInt(mainParts[0]);
    const seconds = parseInt(mainParts[1]);

    if (isNaN(minutes) || isNaN(seconds) || seconds >= 60 || seconds < 0) {
      return null; // Invalid values
    }

    totalSeconds = minutes * 60 + seconds;

    // Parse additional time if exists
    if (parts.length === 2) {
      const additionalTime = parts[1].trim();
      const additionalParts = additionalTime.split(':');

      if (additionalParts.length !== 2) {
        return null; // Invalid format
      }

      const addMinutes = parseInt(additionalParts[0]);
      const addSeconds = parseInt(additionalParts[1]);

      if (isNaN(addMinutes) || isNaN(addSeconds) || addSeconds >= 60 || addSeconds < 0) {
        return null; // Invalid values
      }

      totalSeconds += addMinutes * 60 + addSeconds;
    }

    return totalSeconds;
  }

  handleTimeFieldChange(value, field, originalSeconds) {
    // Parse the time string
    const seconds = this.parseTimeString(value);

    if (seconds === null) {
      // Invalid format - revert to previous value
      const currentValue = $(field.hidden).val();
      const formattedValue = this.player.gamevideojs.returnFormattedDataMatch(parseFloat(currentValue));
      $(field.display).html(formattedValue);
      const message = window.translations?.observation_clips?.errors?.invalid_time_format || 'Invalid format. Use MM:SS or MM:SS+MM:SS';
      toastr.error(message, '', {
        timeOut: 3000
      });
      return;
    }

    // Check if value actually changed (compare seconds)
    if (originalSeconds && parseFloat(originalSeconds) === seconds) {
      // Value didn't change, just reformat and return
      const formattedValue = this.player.gamevideojs.returnFormattedDataMatch(seconds);
      $(field.display).html(formattedValue);
      return;
    }

    // Validate against video duration
    const duration = this.player.duration();
    if (seconds < 0 || seconds > duration) {
      const currentValue = $(field.hidden).val();
      const formattedValue = this.player.gamevideojs.returnFormattedDataMatch(parseFloat(currentValue));
      $(field.display).html(formattedValue);
      const maxTime = this.player.gamevideojs.returnFormattedDataMatch(duration);
      const message = (window.translations?.observation_clips?.errors?.time_out_of_bounds || 'Time out of video bounds (0 to %{max_time})').replace('%{max_time}', maxTime);
      toastr.error(message, '', {
        timeOut: 3000
      });
      return;
    }

    // Format and update display
    const formattedValue = this.player.gamevideojs.returnFormattedDataMatch(seconds);

    // Validate against match rules by comparing formatted output with input
    // If returnFormattedDataMatch adjusted the value, it means the input exceeded match rules
    const normalizedInput = value.trim().replace(/\s/g, '');
    const normalizedFormatted = formattedValue.replace(/\s/g, '');

    if (normalizedInput !== normalizedFormatted) {
      // returnFormattedDataMatch silently corrected the value - it exceeds match rules
      const currentValue = $(field.hidden).val();
      const previousFormattedValue = this.player.gamevideojs.returnFormattedDataMatch(parseFloat(currentValue));
      $(field.display).html(previousFormattedValue);
      const message = window.translations?.observation_clips?.errors?.time_exceeds_match_rules || 'Time exceeds match rules';
      toastr.warning(message, '', {
        timeOut: 3000
      });
      return;
    }

    // Update hidden field with seconds
    $(field.hidden).val(seconds);

    $(field.display).html(formattedValue);

    // Update edit field if exists
    if ($(field.edit).length > 0) {
      $(field.edit).val(formattedValue);
    }

    // Validate time relationships
    if (!this.validateTimeRelationships(field.type)) {
      return;
    }

    // Update range selector if exists
    if (this.rangeSelector) {
      this.updateRangeSelectorPosition();
    }

    // Update player to show the frame
    this.programmaticSeek = true;
    this.player.currentTime(seconds);
  }

  validateTimeRelationships(changedField) {
    const startTime = parseFloat($('.clip_start_time').val());
    const time = parseFloat($('.clip_time').val());
    const endTime = parseFloat($('.clip_end_time').val());

    // Validate: Start < Time < End
    if (startTime >= time) {
      const message = window.translations?.observation_clips?.errors?.start_must_be_less_than_time || 'Start time must be less than main time';
      toastr.warning(message, '', {
        timeOut: 3000
      });
      // Revert
      this.revertFieldValue(changedField);
      return false;
    }

    if (time >= endTime) {
      const message = window.translations?.observation_clips?.errors?.time_must_be_less_than_end || 'Main time must be less than end time';
      toastr.warning(message, '', {
        timeOut: 3000
      });
      // Revert
      this.revertFieldValue(changedField);
      return false;
    }

    if (startTime >= endTime) {
      const message = window.translations?.observation_clips?.errors?.start_must_be_less_than_end || 'Start time must be less than end time';
      toastr.warning(message, '', {
        timeOut: 3000
      });
      // Revert
      this.revertFieldValue(changedField);
      return false;
    }

    return true;
  }

  revertFieldValue(fieldType) {
    // Revert to stored value
    const fieldMap = {
      'start': { hidden: '.clip_start_time', display: '.clip-start-time' },
      'time': { hidden: '.clip_time', display: '.clip-time' },
      'end': { hidden: '.clip_end_time', display: '.clip-end-time' }
    };

    const field = fieldMap[fieldType];
    if (field) {
      const currentValue = $(field.hidden).val();
      const formattedValue = this.player.gamevideojs.returnFormattedDataMatch(parseFloat(currentValue));
      $(field.display).html(formattedValue);
    }
  }

  initializeRangeSelector() {
    if (!this.player) return;

    const progressControl = this.player.controlBar.progressControl.el();
    const progressHolder = progressControl.querySelector('.vjs-progress-holder');

    if (!progressHolder) return;

    // Remove existing range selector if it exists
    this.destroyRangeSelector();

    // Create range selector elements
    this.rangeSelector = this.createRangeSelectorElements();
    progressHolder.style.position = 'relative';
    progressHolder.appendChild(this.rangeSelector);

    // Position handles based on initial values
    this.updateRangeSelectorPosition();

    // Add event listeners for drag
    this.addRangeSelectorListeners();

    // Add class to change play progress bar color
    this.player.el().classList.add('clip-range-selector-active');

    // IMPORTANT: Add play prevention listener during clip creation
    // This catches any attempt by VideoJS to auto-play (e.g., after seekbar interaction)
    const scope = this;
    this._clipCreationPlayPreventionListener = function() {
      // During clip creation, video should NEVER play - only frame changes allowed
      if ($("#create-clip-form").is(":visible")) {
        scope.player.pause();
      }
    };
    this.player.on('play', this._clipCreationPlayPreventionListener);

    // Make the Play button open the preview modal instead of playing during clip creation
    // This provides a useful UX - clicking "Play" shows a preview of the clip being created
    const playButton = this.player.el().querySelector('.vjs-play-control');
    if (playButton) {
      this._playButtonClickHandler = function(e) {
        if ($("#create-clip-form").is(":visible")) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          scope.openClipPreviewModal();
        }
      };
      // Use capture phase to intercept before VideoJS handles the click
      playButton.addEventListener('click', this._playButtonClickHandler, true);
    }

    // IMPORTANT: Block clicks on the seek bar during clip creation
    // Navigation should only be done via the range selector handles
    // This prevents accidental recalculation of clip times when user clicks on progress bar
    this._seekBarClickBlocker = function(e) {
      if ($("#create-clip-form").is(":visible")) {
        // Allow interactions with the range selector elements (handles, area, time marker)
        const target = e.target;
        const isRangeSelectorElement = target.closest('.clip-range-selector') ||
                                        target.classList.contains('clip-handle') ||
                                        target.classList.contains('clip-range-area') ||
                                        target.classList.contains('clip-time-marker') ||
                                        target.classList.contains('clip-handle-tooltip');

        // Only block if NOT interacting with range selector elements
        if (!isRangeSelectorElement) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    };
    // Use capture phase to intercept BEFORE VideoJS handles the click
    progressHolder.addEventListener('click', this._seekBarClickBlocker, true);
    progressHolder.addEventListener('mousedown', this._seekBarClickBlocker, true);

    // Force position update after a short delay to ensure crop conversion is complete
    setTimeout(() => {
      scope.updateRangeSelectorPosition();
    }, 150);
  }

  createRangeSelectorElements() {
    const container = document.createElement('div');
    container.className = 'clip-range-selector';

    // Create range area (the colored area between handles)
    this.rangeArea = document.createElement('div');
    this.rangeArea.className = 'clip-range-area';
    container.appendChild(this.rangeArea);

    // Create Time marker (fixed vertical line at the Time position)
    this.timeMarker = document.createElement('div');
    this.timeMarker.className = 'clip-time-marker';
    this.timeMarker.title = 'Time (Fixed Point of Interest)';
    container.appendChild(this.timeMarker);

    // Create Preview Scrubber (yellow ball that follows mouse hover for frame preview)
    this.previewScrubber = document.createElement('div');
    this.previewScrubber.className = 'clip-preview-scrubber';
    this.tooltipPreview = document.createElement('div');
    this.tooltipPreview.className = 'clip-preview-scrubber-tooltip';
    this.tooltipPreview.textContent = '00:00';
    this.previewScrubber.appendChild(this.tooltipPreview);
    container.appendChild(this.previewScrubber);

    // Create start handle
    this.handleStart = document.createElement('div');
    this.handleStart.className = 'clip-handle clip-handle-start';
    this.handleStart.setAttribute('data-handle', 'start');

    this.tooltipStart = document.createElement('div');
    this.tooltipStart.className = 'clip-handle-tooltip';
    this.tooltipStart.textContent = '00:00';
    this.handleStart.appendChild(this.tooltipStart);
    container.appendChild(this.handleStart);

    // Create end handle
    this.handleEnd = document.createElement('div');
    this.handleEnd.className = 'clip-handle clip-handle-end';
    this.handleEnd.setAttribute('data-handle', 'end');

    this.tooltipEnd = document.createElement('div');
    this.tooltipEnd.className = 'clip-handle-tooltip';
    this.tooltipEnd.textContent = '00:00';
    this.handleEnd.appendChild(this.tooltipEnd);
    container.appendChild(this.handleEnd);

    return container;
  }

  updateRangeSelectorPosition() {
    if (!this.player || !this.rangeSelector) return;

    const duration = this.player.duration();
    if (duration === 0) return;

    let startTime = parseFloat($('.clip_start_time').val()) || 0;
    let timeValue = parseFloat($('.clip_time').val()) || 0;
    let endTime = parseFloat($('.clip_end_time').val()) || 0;

    // IMPORTANT: Ensure times are within valid range
    // This prevents handles from going off-screen
    startTime = Math.max(0, Math.min(startTime, duration));
    timeValue = Math.max(0, Math.min(timeValue, duration));
    endTime = Math.max(0, Math.min(endTime, duration));

    const startPercent = (startTime / duration) * 100;
    const timePercent = (timeValue / duration) * 100;
    const endPercent = (endTime / duration) * 100;

    // Clamp percentages to 0-100% to prevent off-screen positioning
    const clampedStartPercent = Math.max(0, Math.min(100, startPercent));
    const clampedTimePercent = Math.max(0, Math.min(100, timePercent));
    const clampedEndPercent = Math.max(0, Math.min(100, endPercent));

    // Update handle positions
    this.handleStart.style.left = clampedStartPercent + '%';
    this.handleEnd.style.left = clampedEndPercent + '%';

    // Update range area
    this.rangeArea.style.left = clampedStartPercent + '%';
    this.rangeArea.style.width = (clampedEndPercent - clampedStartPercent) + '%';

    // Update Time marker position (fixed point)
    if (this.timeMarker) {
      this.timeMarker.style.left = clampedTimePercent + '%';
    }

    // Update Preview Scrubber initial position (same as Time marker)
    if (this.previewScrubber && !this._previewScrubberInitialized) {
      this.previewScrubber.style.left = clampedTimePercent + '%';
      const displayTimeValue = this.cropApplied ? (timeValue + this.viewportStart) : timeValue;
      this.tooltipPreview.textContent = this.player.gamevideojs.returnFormattedDataMatch(displayTimeValue);
      this._previewScrubberInitialized = true;
    }

    // Update tooltips - show absolute times when crop is applied
    const displayStartTime = this.cropApplied ? (startTime + this.viewportStart) : startTime;
    const displayEndTime = this.cropApplied ? (endTime + this.viewportStart) : endTime;
    this.tooltipStart.textContent = this.player.gamevideojs.returnFormattedDataMatch(displayStartTime);
    this.tooltipEnd.textContent = this.player.gamevideojs.returnFormattedDataMatch(displayEndTime);
  }

  addRangeSelectorListeners() {
    const scope = this;

    // Mouse down on handles
    const handleMouseDown = function(e) {
      e.preventDefault();
      e.stopPropagation();
      // IMPORTANT: Pause player to prevent VideoJS from auto-playing after mouseup
      // VideoJS remembers if video was playing before scrubbing and auto-plays on mouseup
      scope.pausePlayer();
      scope.isDragging = true;
      scope.currentHandle = this.getAttribute('data-handle');
      this.classList.add('dragging');
    };

    this.handleStart.addEventListener('mousedown', handleMouseDown);
    this.handleEnd.addEventListener('mousedown', handleMouseDown);

    // Touch support for mobile
    this.handleStart.addEventListener('touchstart', handleMouseDown);
    this.handleEnd.addEventListener('touchstart', handleMouseDown);

    // Mouse down on range area (to drag the entire selector)
    const areaMouseDown = function(e) {
      e.preventDefault();
      e.stopPropagation();
      // IMPORTANT: Pause player to prevent VideoJS from auto-playing after mouseup
      scope.pausePlayer();
      scope.isDraggingArea = true;

      const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      scope.dragStartX = clientX;

      // Store current times
      const startTime = parseFloat($('.clip_start_time').val());
      const timeValue = parseFloat($('.clip_time').val());
      const endTime = parseFloat($('.clip_end_time').val());
      scope.dragStartTime = startTime;
      scope.dragStartTimeValue = timeValue;  // Store Time marker position
      scope.clipDuration = endTime - startTime;

      scope.rangeArea.style.cursor = 'grabbing';
    };

    this.rangeArea.addEventListener('mousedown', areaMouseDown);
    this.rangeArea.addEventListener('touchstart', areaMouseDown);

    // Mouse move on document
    const handleMouseMove = function(e) {
      if (scope.isDragging) {
        // Support both mouse and touch events
        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        scope.onHandleDrag(clientX);
      } else if (scope.isDraggingArea) {
        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        scope.onAreaDrag(clientX);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchmove', handleMouseMove);

    // Mouse up on document
    const handleMouseUp = function(e) {
      const wasDragging = scope.isDragging || scope.isDraggingArea;

      if (scope.isDragging) {
        scope.isDragging = false;
        if (scope.handleStart) scope.handleStart.classList.remove('dragging');
        if (scope.handleEnd) scope.handleEnd.classList.remove('dragging');
        scope.currentHandle = null;
      }

      if (scope.isDraggingArea) {
        scope.isDraggingArea = false;
        if (scope.rangeArea) scope.rangeArea.style.cursor = 'grab';
      }

      // IMPORTANT: Ensure video stays paused after drag during clip creation
      // This is a safety measure in case VideoJS still tries to auto-play
      if (wasDragging && $("#create-clip-form").is(":visible")) {
        scope.pausePlayer();
      }
    };

    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchend', handleMouseUp);

    // Preview Scrubber - follows mouse hover within range area
    const previewScrubberMove = function(e) {
      // Don't update preview scrubber while dragging handles
      if (scope.isDragging || scope.isDraggingArea) return;

      scope.onPreviewScrubberMove(e);
    };

    this.rangeArea.addEventListener('mousemove', previewScrubberMove);

    // Store listeners for cleanup
    this._rangeSelectorListeners = {
      handleMouseDown,
      areaMouseDown,
      handleMouseMove,
      handleMouseUp,
      previewScrubberMove
    };
  }

  onHandleDrag(clientX) {
    if (!this.player || !this.currentHandle) return;

    const progressControl = this.player.controlBar.progressControl.el();
    const progressHolder = progressControl.querySelector('.vjs-progress-holder');
    const rect = progressHolder.getBoundingClientRect();
    const duration = this.player.duration();

    if (duration === 0) return;

    // Calculate relative mouse position
    let mouseX = clientX - rect.left;
    mouseX = Math.max(0, Math.min(mouseX, rect.width)); // Limit to bounds

    const percent = mouseX / rect.width;
    const newTime = duration * percent;

    const clipStartTimeField = $('.clip_start_time');
    const clipTimeField = $('.clip_time');
    const clipEndTimeField = $('.clip_end_time');

    const clipStartTimeView = $('.clip-start-time');
    const clipTimeView = $('.clip-time');
    const clipEndTimeView = $('.clip-end-time');

    const editClipStartTimeField = $('.edit_clip_start_time');
    const editClipTimeField = $('.edit_clip_time');
    const editClipEndTimeField = $('.edit_clip_end_time');

    let startTime = parseFloat(clipStartTimeField.val());
    let endTime = parseFloat(clipEndTimeField.val());

    // Get the fixed Time value (should not be recalculated)
    const timeValue = parseFloat(clipTimeField.val());

    // Update the appropriate field
    let playerTime;

    if (this.currentHandle === 'start') {
      // Validate: Start cannot exceed Time (fixed point)
      const clampedTime = Math.min(newTime, timeValue - 1, endTime - 1);
      startTime = Math.max(0, clampedTime);

      clipStartTimeField.val(startTime);

      // Calculate absolute time for display (if crop is applied)
      const displayStartTime = this.cropApplied ? (startTime + this.viewportStart) : startTime;
      this.absoluteStartTime = displayStartTime;

      clipStartTimeView.html(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));

      if (editClipStartTimeField.length > 0) {
        editClipStartTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));
      }

      this.updateTooltip('start', displayStartTime);

      // When dragging start handle, show the start frame
      playerTime = startTime;

    } else if (this.currentHandle === 'end') {
      // Validate: End cannot be before Time (fixed point)
      const clampedTime = Math.max(newTime, timeValue + 1, startTime + 1);
      endTime = clampedTime;

      clipEndTimeField.val(endTime);

      // Calculate absolute time for display (if crop is applied)
      const displayEndTime = this.cropApplied ? (endTime + this.viewportStart) : endTime;
      this.absoluteEndTime = displayEndTime;

      clipEndTimeView.html(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));

      if (editClipEndTimeField.length > 0) {
        editClipEndTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));
      }

      this.updateTooltip('end', displayEndTime);

      // When dragging end handle, show the end frame
      playerTime = endTime;
    }

    // NOTE: Time (middle marker) should remain FIXED when dragging handles
    // It only moves when the entire area is dragged together
    // The user's point of interest (Time) should not be recalculated automatically

    // Update visual position of handles
    this.updateRangeSelectorPosition();

    // Update player time to the handle being dragged
    this.programmaticSeek = true;
    this.player.currentTime(playerTime);

    // Update custom time displays if they exist
    this.updateCustomTimeDisplays();

    // Update viewport buttons state (clip size may have changed)
    this.updateViewportButtonsState();
  }

  onAreaDrag(clientX) {
    if (!this.player) return;

    const progressControl = this.player.controlBar.progressControl.el();
    const progressHolder = progressControl.querySelector('.vjs-progress-holder');
    const rect = progressHolder.getBoundingClientRect();
    const duration = this.player.duration();

    if (duration === 0) return;

    // Calculate mouse movement in pixels
    const deltaX = clientX - this.dragStartX;

    // Convert pixel movement to time
    const deltaTime = (deltaX / rect.width) * duration;

    // Calculate new start time
    let newStartTime = this.dragStartTime + deltaTime;
    let newEndTime = newStartTime + this.clipDuration;

    // Prevent going out of bounds
    if (newStartTime < 0) {
      newStartTime = 0;
      newEndTime = this.clipDuration;
    }

    if (newEndTime > duration) {
      newEndTime = duration;
      newStartTime = duration - this.clipDuration;
    }

    // Update fields
    const clipStartTimeField = $('.clip_start_time');
    const clipTimeField = $('.clip_time');
    const clipEndTimeField = $('.clip_end_time');

    const clipStartTimeView = $('.clip-start-time');
    const clipTimeView = $('.clip-time');
    const clipEndTimeView = $('.clip-end-time');

    const editClipStartTimeField = $('.edit_clip_start_time');
    const editClipTimeField = $('.edit_clip_time');
    const editClipEndTimeField = $('.edit_clip_end_time');

    // Calculate absolute times for display (if crop is applied)
    const displayStartTime = this.cropApplied ? (newStartTime + this.viewportStart) : newStartTime;
    const displayEndTime = this.cropApplied ? (newEndTime + this.viewportStart) : newEndTime;

    // Store absolute values
    this.absoluteStartTime = displayStartTime;
    this.absoluteEndTime = displayEndTime;
    // Note: this.absoluteTime will be updated later when calculating newTime with proportional offset

    // Update start time
    clipStartTimeField.val(newStartTime);
    clipStartTimeView.html(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));
    if (editClipStartTimeField.length > 0) {
      editClipStartTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayStartTime));
    }

    // Update end time
    clipEndTimeField.val(newEndTime);
    clipEndTimeView.html(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));
    if (editClipEndTimeField.length > 0) {
      editClipEndTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayEndTime));
    }

    // Update Time maintaining its proportional position within the range
    // Calculate the proportional position of Time within the original range (0 to 1)
    const originalTimeOffset = (this.dragStartTimeValue - this.dragStartTime) / this.clipDuration;

    // Apply the same proportion to the new range to maintain relative position
    const newTime = newStartTime + (this.clipDuration * originalTimeOffset);
    const displayTime = this.cropApplied ? (newTime + this.viewportStart) : newTime;

    clipTimeField.val(newTime);
    clipTimeView.html(this.player.gamevideojs.returnFormattedDataMatch(displayTime));
    if (editClipTimeField.length > 0) {
      editClipTimeField.val(this.player.gamevideojs.returnFormattedDataMatch(displayTime));
    }

    // Update stored absolute Time value
    this.absoluteTime = displayTime;

    // Update visual position
    this.updateRangeSelectorPosition();

    // Update tooltips
    this.updateTooltip('start', displayStartTime);
    this.updateTooltip('end', displayEndTime);

    // Update player time to the Time marker position
    this.programmaticSeek = true;
    this.player.currentTime(newTime);

    // Update custom time displays if they exist
    this.updateCustomTimeDisplays();
  }

  onPreviewScrubberMove(e) {
    if (!this.player || !this.rangeArea || !this.previewScrubber) return;

    const progressControl = this.player.controlBar.progressControl.el();
    const progressHolder = progressControl.querySelector('.vjs-progress-holder');
    const progressRect = progressHolder.getBoundingClientRect();
    const areaRect = this.rangeArea.getBoundingClientRect();
    const duration = this.player.duration();

    if (duration === 0) return;

    // Get mouse position relative to range area
    const mouseX = e.clientX - areaRect.left;
    const clampedX = Math.max(0, Math.min(mouseX, areaRect.width));

    // Calculate percentage within range area (0 to 1)
    const percentWithinArea = clampedX / areaRect.width;

    // Get current start and end times from fields
    const startTime = parseFloat($('.clip_start_time').val());
    const endTime = parseFloat($('.clip_end_time').val());

    // Calculate preview time based on position within the clip range
    const previewTime = startTime + (percentWithinArea * (endTime - startTime));

    // Calculate position relative to progress holder (for visual positioning)
    const absoluteLeft = areaRect.left - progressRect.left + clampedX;
    const percentLeft = (absoluteLeft / progressRect.width) * 100;

    // Update scrubber position
    this.previewScrubber.style.left = percentLeft + '%';

    // Update tooltip with formatted time
    const displayTime = this.cropApplied ? (previewTime + this.viewportStart) : previewTime;
    this.tooltipPreview.textContent = this.player.gamevideojs.returnFormattedDataMatch(displayTime);

    // Update video frame WITHOUT updating any fields
    this.programmaticSeek = true;
    this.player.currentTime(previewTime);
  }

  updateTooltip(handleType, timeInSeconds) {
    const tooltip = handleType === 'start' ? this.tooltipStart : this.tooltipEnd;
    if (!tooltip) return;

    // Convert to absolute time if crop is applied
    const displayTime = this.cropApplied ? (timeInSeconds + this.viewportStart) : timeInSeconds;
    const formattedTime = this.player.gamevideojs.returnFormattedDataMatch(displayTime);
    tooltip.textContent = formattedTime;
  }

  destroyRangeSelector() {
    if (this.rangeSelector && this.rangeSelector.parentNode) {
      this.rangeSelector.parentNode.removeChild(this.rangeSelector);
    }

    // Clean up event listeners
    if (this._rangeSelectorListeners) {
      document.removeEventListener('mousemove', this._rangeSelectorListeners.handleMouseMove);
      document.removeEventListener('mouseup', this._rangeSelectorListeners.handleMouseUp);
      document.removeEventListener('touchmove', this._rangeSelectorListeners.handleMouseMove);
      document.removeEventListener('touchend', this._rangeSelectorListeners.handleMouseUp);
    }

    // Remove class that changes play progress bar color
    if (this.player && this.player.el()) {
      this.player.el().classList.remove('clip-range-selector-active');
    }

    // Remove play prevention listener
    if (this._clipCreationPlayPreventionListener && this.player) {
      this.player.off('play', this._clipCreationPlayPreventionListener);
      this._clipCreationPlayPreventionListener = null;
    }

    // Remove play button click handler that opens preview modal
    if (this._playButtonClickHandler && this.player) {
      const playButton = this.player.el().querySelector('.vjs-play-control');
      if (playButton) {
        playButton.removeEventListener('click', this._playButtonClickHandler, true);
      }
      this._playButtonClickHandler = null;
    }

    // Remove seek bar click blocker
    if (this._seekBarClickBlocker && this.player) {
      const progressControl = this.player.controlBar.progressControl.el();
      const progressHolder = progressControl?.querySelector('.vjs-progress-holder');
      if (progressHolder) {
        progressHolder.removeEventListener('click', this._seekBarClickBlocker, true);
        progressHolder.removeEventListener('mousedown', this._seekBarClickBlocker, true);
      }
      this._seekBarClickBlocker = null;
    }

    this.rangeSelector = null;
    this.rangeArea = null;
    this.handleStart = null;
    this.handleEnd = null;
    this.tooltipStart = null;
    this.tooltipEnd = null;
    this.previewScrubber = null;
    this.tooltipPreview = null;
    this._previewScrubberInitialized = false;
    this.isDragging = false;
    this.currentHandle = null;
    this.isDraggingArea = false;
    this.dragStartX = 0;
    this.dragStartTime = 0;
    this.dragStartTimeValue = 0;
    this.clipDuration = 0;
  }

  // ========================================
  // Viewport Adjustment Methods
  // ========================================

  initializeViewportButtons() {
    const scope = this;

    // Remove any existing listeners to avoid duplicates
    $("#btn-viewport-increase").off("click");
    $("#btn-viewport-decrease").off("click");

    // Add click listeners
    $("#btn-viewport-increase").on("click", function() {
      scope.expandViewport();
    });

    $("#btn-viewport-decrease").on("click", function() {
      scope.reduceViewport();
    });

    // Update initial state
    this.updateViewportButtonsState();
    this.updateViewportIndicator();
  }

  /**
   * Get the effective maximum viewport size (limited by video duration)
   */
  getEffectiveMaxViewport() {
    const videoDuration = this.originalDuration || this.player.duration();
    return Math.min(this.VIEWPORT_MAX, videoDuration);
  }

  /**
   * Get current viewport duration
   */
  getCurrentViewportDuration() {
    if (this.viewportStart !== null && this.viewportEnd !== null) {
      return this.viewportEnd - this.viewportStart;
    }
    return this.VIEWPORT_MIN;
  }

  /**
   * Calculate how to distribute expansion between left and right sides
   */
  calculateExpansion(incremento = this.VIEWPORT_INCREMENT) {
    const videoDuration = this.originalDuration || this.player.duration();
    const metade = incremento / 2;

    // Space available on each side
    const espacoEsquerda = this.viewportStart;
    const espacoDireita = videoDuration - this.viewportEnd;

    // Total available space
    const espacoTotal = espacoEsquerda + espacoDireita;

    // If not enough space, expand as much as possible
    const expansaoReal = Math.min(incremento, espacoTotal);

    if (expansaoReal <= 0) {
      return null; // Cannot expand
    }

    // Distribute the expansion
    let expandirEsquerda, expandirDireita;

    if (espacoEsquerda >= metade && espacoDireita >= metade) {
      // Ideal case: expand equally on both sides
      expandirEsquerda = metade;
      expandirDireita = metade;
    } else if (espacoEsquerda < metade) {
      // Little space on the left: use what's available and complement on the right
      expandirEsquerda = espacoEsquerda;
      expandirDireita = Math.min(expansaoReal - expandirEsquerda, espacoDireita);
    } else {
      // Little space on the right: use what's available and complement on the left
      expandirDireita = espacoDireita;
      expandirEsquerda = Math.min(expansaoReal - expandirDireita, espacoEsquerda);
    }

    return {
      novoStart: this.viewportStart - expandirEsquerda,
      novoEnd: this.viewportEnd + expandirDireita,
      expansaoTotal: expandirEsquerda + expandirDireita
    };
  }

  /**
   * Expand the viewport by INCREMENT seconds
   */
  expandViewport() {
    if (!this.cropApplied || !this.player) return;

    const currentDuration = this.getCurrentViewportDuration();
    const maxViewport = this.getEffectiveMaxViewport();

    // Check if we can expand
    if (currentDuration >= maxViewport) {
      return;
    }

    // Calculate expansion
    const expansion = this.calculateExpansion();
    if (!expansion) {
      return;
    }

    // Calculate how much viewport start is moving (negative means moving left/earlier)
    const viewportStartDelta = expansion.novoStart - this.viewportStart;

    // Save current player position (absolute time)
    const currentRelativeTime = this.player.currentTime();
    const currentAbsoluteTime = currentRelativeTime + this.viewportStart;

    // Update viewport values
    this.viewportStart = expansion.novoStart;
    this.viewportEnd = expansion.novoEnd;

    // Get cropMatch offset if applicable
    const cropMatch = this.player.gamevideojs.cropMatch;
    const firstMatchStartTime = this.player.gamevideojs.firstMatchStartTime || 0;
    const cropOffset = (cropMatch && firstMatchStartTime) ? firstMatchStartTime : 0;

    // Apply new crop
    const absoluteViewportStart = this.viewportStart + cropOffset;
    const absoluteViewportEnd = this.viewportEnd + cropOffset;

    this.player.gamevideojs.setCrop(absoluteViewportStart, absoluteViewportEnd);

    // Reposition player to maintain the same absolute time
    const newRelativeTime = currentAbsoluteTime - this.viewportStart;
    this.programmaticSeek = true;
    this.player.currentTime(newRelativeTime);

    // Update clip times to be relative to new viewport
    // viewportStartDelta is negative when expanding left, so we subtract it (add positive value)
    this.convertClipTimesToNewViewport(viewportStartDelta);

    // Update range selector positions (handles maintain absolute positions)
    this.updateRangeSelectorPosition();

    // Update custom time displays
    this.updateCustomTimeDisplays();

    // Update viewport buttons state and indicator
    this.updateViewportButtonsState();
    this.updateViewportIndicator();
  }

  /**
   * Reduce the viewport by INCREMENT seconds
   */
  reduceViewport() {
    if (!this.cropApplied || !this.player) return;

    const currentDuration = this.getCurrentViewportDuration();

    // Check if we can reduce
    if (currentDuration <= this.VIEWPORT_MIN) {
      return;
    }

    // Check if clip fits in the new viewport
    const clipStartTime = parseFloat($('.clip_start_time').val()) || 0;
    const clipEndTime = parseFloat($('.clip_end_time').val()) || 0;
    const clipDuration = clipEndTime - clipStartTime;
    const newViewportDuration = currentDuration - this.VIEWPORT_INCREMENT;

    if (clipDuration > newViewportDuration) {
      return;
    }

    // Calculate how much we can reduce on each side
    const metade = this.VIEWPORT_INCREMENT / 2;

    // Space available to reduce on each side (limited by clip position)
    const espacoEsquerda = clipStartTime; // How much space between viewport start and clip start
    const espacoDireita = currentDuration - clipEndTime; // How much space between clip end and viewport end

    // Distribute the reduction
    let reduzirEsquerda, reduzirDireita;

    if (espacoEsquerda >= metade && espacoDireita >= metade) {
      // Ideal case: reduce equally on both sides
      reduzirEsquerda = metade;
      reduzirDireita = metade;
    } else if (espacoEsquerda < metade) {
      // Little space on the left: use what's available and complement on the right
      reduzirEsquerda = Math.min(espacoEsquerda, metade);
      reduzirDireita = Math.min(this.VIEWPORT_INCREMENT - reduzirEsquerda, espacoDireita);
    } else {
      // Little space on the right: use what's available and complement on the left
      reduzirDireita = Math.min(espacoDireita, metade);
      reduzirEsquerda = Math.min(this.VIEWPORT_INCREMENT - reduzirDireita, espacoEsquerda);
    }

    // Check if total reduction is enough
    const reducaoTotal = reduzirEsquerda + reduzirDireita;
    if (reducaoTotal < this.VIEWPORT_INCREMENT) {
      // Partial reduction - check if it would still be above minimum
      if (currentDuration - reducaoTotal < this.VIEWPORT_MIN) {
        return;
      }
    }

    const novoStart = this.viewportStart + reduzirEsquerda;
    const novoEnd = this.viewportEnd - reduzirDireita;

    // Save current player position (absolute time)
    const currentRelativeTime = this.player.currentTime();
    const currentAbsoluteTime = currentRelativeTime + this.viewportStart;

    // Update viewport values
    this.viewportStart = novoStart;
    this.viewportEnd = novoEnd;

    // Get cropMatch offset if applicable
    const cropMatch = this.player.gamevideojs.cropMatch;
    const firstMatchStartTime = this.player.gamevideojs.firstMatchStartTime || 0;
    const cropOffset = (cropMatch && firstMatchStartTime) ? firstMatchStartTime : 0;

    // Apply new crop
    const absoluteViewportStart = this.viewportStart + cropOffset;
    const absoluteViewportEnd = this.viewportEnd + cropOffset;

    this.player.gamevideojs.setCrop(absoluteViewportStart, absoluteViewportEnd);

    // Reposition player to maintain the same absolute time
    const newRelativeTime = currentAbsoluteTime - this.viewportStart;
    this.programmaticSeek = true;
    this.player.currentTime(newRelativeTime);

    // Update clip times to be relative to new viewport
    this.convertClipTimesToNewViewport(reduzirEsquerda);

    // Update range selector positions
    this.updateRangeSelectorPosition();

    // Update custom time displays
    this.updateCustomTimeDisplays();

    // Update viewport buttons state and indicator
    this.updateViewportButtonsState();
    this.updateViewportIndicator();
  }

  /**
   * Convert clip times when viewport changes
   * @param {number} startOffset - How much the viewport start moved
   */
  convertClipTimesToNewViewport(startOffset) {
    // The clip times are stored as relative to the viewport
    // When viewport start moves, we need to adjust the clip times
    const clipStartTime = parseFloat($('.clip_start_time').val()) || 0;
    const clipTime = parseFloat($('.clip_time').val()) || 0;
    const clipEndTime = parseFloat($('.clip_end_time').val()) || 0;

    const newStartTime = clipStartTime - startOffset;
    const newTime = clipTime - startOffset;
    const newEndTime = clipEndTime - startOffset;

    $('.clip_start_time').val(newStartTime);
    $('.clip_time').val(newTime);
    $('.clip_end_time').val(newEndTime);
  }

  /**
   * Update the enabled/disabled state of viewport buttons
   */
  updateViewportButtonsState() {
    const currentDuration = this.getCurrentViewportDuration();
    const maxViewport = this.getEffectiveMaxViewport();
    const videoDuration = this.originalDuration || this.player.duration();

    // Check if we can expand
    const canExpand = currentDuration < maxViewport &&
                      (this.viewportStart > 0 || this.viewportEnd < videoDuration);

    // Check if we can reduce
    const clipStartTime = parseFloat($('.clip_start_time').val()) || 0;
    const clipEndTime = parseFloat($('.clip_end_time').val()) || 0;
    const clipDuration = clipEndTime - clipStartTime;
    const newViewportDuration = currentDuration - this.VIEWPORT_INCREMENT;
    const canReduce = currentDuration > this.VIEWPORT_MIN && clipDuration <= newViewportDuration;

    // Update button states
    $("#btn-viewport-increase").prop("disabled", !canExpand);
    $("#btn-viewport-decrease").prop("disabled", !canReduce);
  }

  /**
   * Update the viewport indicator display
   */
  updateViewportIndicator() {
    const currentDuration = this.getCurrentViewportDuration();
    const maxViewport = this.getEffectiveMaxViewport();

    // Format as M:SS
    const formatTime = (seconds) => {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    $(".viewport-current").text(formatTime(currentDuration));
    $(".viewport-max").text(formatTime(maxViewport));
  }

  // ========================================
  // Clip Preview Methods
  // ========================================

  initializeClipPreviewButton() {
    const scope = this;

    // Remove any existing listener to avoid duplicates
    $("#btn-preview-clip").off("click");

    $("#btn-preview-clip").on("click", function(event) {
      event.preventDefault();
      scope.openClipPreviewModal();
    });

    // Setup modal cleanup (only once)
    if (!scope._previewModalCleanupInitialized) {
      scope.setupPreviewModalCleanup();
      scope._previewModalCleanupInitialized = true;
    }
  }

  openClipPreviewModal() {
    // 1. Capture current clip times
    let startTime = parseFloat($('.clip_start_time').val());
    let endTime = parseFloat($('.clip_end_time').val());

    // 2. Convert to absolute times if crop is applied
    let absoluteStartTime = startTime;
    let absoluteEndTime = endTime;

    if (this.cropApplied && this.viewportStart) {
      absoluteStartTime = startTime + this.viewportStart;
      absoluteEndTime = endTime + this.viewportStart;
    }

    // 3. Prepare container with absolute times in data attributes
    this.preparePreviewPlayerContainer(absoluteStartTime, absoluteEndTime);

    // 4. Show modal first, then create player
    $('#clip-preview-modal').modal('show');

    // 5. Create player after modal is shown (to avoid initialization issues)
    $('#clip-preview-modal').one('shown.bs.modal', () => {
      this.createPreviewPlayer(absoluteStartTime, absoluteEndTime);
    });
  }

  preparePreviewPlayerContainer(absoluteStartTime, absoluteEndTime) {
    const container = $('#clip-preview-player-container');

    // Destroy existing preview player if any
    if (this.previewPlayer) {
      this.previewPlayer.dispose();
      this.previewPlayer = null;
    }

    // Clear container
    container.html('');

    // Get match time data from main player
    const mainPlayerElement = $('#appointment-player')[0];
    const firstMatchStartTime = $(mainPlayerElement).data('first-match-start-time') || 0;
    const secondMatchStartTime = $(mainPlayerElement).data('second-match-start-time') || 0;

    // Create video element EXACTLY like clips modal with data-start-crop and data-end-crop
    const videoElement = `
      <video-js
        id="clip-preview-video"
        class="video-js vjs-big-play-centered hidde-vjs-load-progress-circle clips-view-modal__video-player"
        controls
        preload="auto"
        muted="true"
        data-crop-match="true"
        data-first-match-start-time="${firstMatchStartTime}"
        data-second-match-start-time="${secondMatchStartTime}"
        data-start-crop="${absoluteStartTime}"
        data-end-crop="${absoluteEndTime}"
        data-setup='{"liveui": true, "fluid": true}'>
        <source src="${this.player.currentSrc()}" type="${this.player.currentType()}">
      </video-js>
    `;

    container.html(videoElement);
  }

  createPreviewPlayer(startTime, endTime) {
    const scope = this;

    // Calculate clip duration
    const clipDuration = endTime - startTime;
    const formattedDuration = this.player.gamevideojs.returnFormattedDataMatch(clipDuration);
    const formattedStart = this.player.gamevideojs.returnFormattedDataMatch(startTime);
    const formattedEnd = this.player.gamevideojs.returnFormattedDataMatch(endTime);

    // Update info text in modal footer
    $('#clip-preview-info').text(
      `Tocando de ${formattedStart} até ${formattedEnd} (${formattedDuration})`
    );

    // Initialize using gamevideojs EXACTLY like clips
    // gamevideojs will read data-start-crop and data-end-crop attributes automatically
    this.previewPlayer = gamevideojs('#clip-preview-video', {
      controls: true,
      autoplay: true,
      preload: 'auto'
    });

    // Wait for player to be ready
    this.previewPlayer.ready(function() {
      // gamevideojs already applied crop via data-start-crop/data-end-crop
      // Just play
      this.play();

      // Loop when clip ends
      this.on('ended', function() {
        this.currentTime(0);
        this.play();
      });
    });
  }

  setupPreviewModalCleanup() {
    const scope = this;

    $('#clip-preview-modal').on('hidden.bs.modal', function() {
      // Destroy preview player
      if (scope.previewPlayer) {
        scope.previewPlayer.dispose();
        scope.previewPlayer = null;
      }

      // Clear container
      $('#clip-preview-player-container').html('');

      // Clear info text
      $('#clip-preview-info').text('');
    });
  }

  // ========================================
  // Jump to Time Methods
  // ========================================

  initializeJumpToTime() {
    const scope = this;

    const input = $("#jump-to-time-input");

    // Listener on Go button
    $("#jump-to-time-btn").off("click");
    $("#jump-to-time-btn").on("click", function(event) {
      event.preventDefault();
      scope.handleJumpToTime();
    });

    // Listener on Enter key in input
    input.off("keypress");
    input.on("keypress", function(event) {
      if (event.which === 13) { // Enter key
        event.preventDefault();
        scope.handleJumpToTime();
      }
    });

    // Prevent non-numeric characters except : and +
    input.off("keydown.jumpmask");
    input.on("keydown.jumpmask", function(e) {
      // Allow: backspace, delete, tab, escape, enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
          // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+C, Command+C
          (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+V, Command+V
          (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+X, Command+X
          (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }

      // Prevent non-numeric characters except : and +
      if (e.key && e.key.length === 1 && !/[\d:+]/.test(e.key)) {
        e.preventDefault();
      }
    });

    // Apply mask during typing
    input.off("input.jumpmask");
    input.on("input.jumpmask", function() {
      scope.applyJumpToTimeMask(this);
    });

    // Handle paste
    input.off("paste.jumpmask");
    input.on("paste.jumpmask", function(e) {
      e.preventDefault();
      const text = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
      const cleaned = text.replace(/[^\d:+]/g, '');

      // Insert at cursor position
      const start = this.selectionStart;
      const end = this.selectionEnd;
      const currentValue = $(this).val();
      const newValue = currentValue.substring(0, start) + cleaned + currentValue.substring(end);
      $(this).val(newValue);

      // Trigger input event to apply mask
      $(this).trigger('input');

      // Set cursor position
      const newPosition = start + cleaned.length;
      this.setSelectionRange(newPosition, newPosition);
    });

    // Visual feedback on focus
    input.off("focus.jumpmask");
    input.on("focus.jumpmask", function() {
      $(this).css('background-color', 'rgba(255, 255, 255, 0.2)');
      // Select all text
      this.select();
    });

    input.off("blur.jumpmask");
    input.on("blur.jumpmask", function() {
      $(this).css('background-color', 'rgba(255, 255, 255, 0.1)');
    });
  }

  applyJumpToTimeMask(input) {
    // Get current value and cursor position
    const cursorPosition = input.selectionStart;
    let value = $(input).val();

    // Count how many digits are before the cursor
    let digitsBeforeCursor = 0;
    let plusBeforeCursor = false;
    for (let i = 0; i < cursorPosition && i < value.length; i++) {
      if (/\d/.test(value[i])) {
        digitsBeforeCursor++;
      }
      if (value[i] === '+') {
        plusBeforeCursor = true;
      }
    }

    // Remove all non-numeric characters except +
    let cleanValue = value.replace(/[^\d+]/g, '');

    if (cleanValue.length === 0) {
      return;
    }

    // Check if has + (additional time)
    const hasPlus = cleanValue.includes('+');

    let formatted;
    if (hasPlus) {
      // Format: MM:SS+MM:SS
      const parts = cleanValue.split('+');
      let mainPart = parts[0] || '';
      let additionalPart = parts[1] || '';

      // Format main part (MM:SS)
      mainPart = this.formatJumpTimePart(mainPart);

      // Format additional part (MM:SS)
      additionalPart = this.formatJumpTimePart(additionalPart);

      // Combine
      formatted = additionalPart ? mainPart + '+' + additionalPart : mainPart + '+';
    } else {
      // Format: MM:SS
      formatted = this.formatJumpTimePart(cleanValue);
    }

    // Update input
    $(input).val(formatted);

    // Calculate new cursor position based on digits before cursor
    let newCursorPosition = 0;
    let digitsCount = 0;
    let foundPlus = false;

    for (let i = 0; i < formatted.length; i++) {
      // If we were after the + before, make sure we're after it now
      if (formatted[i] === '+') {
        foundPlus = true;
        if (plusBeforeCursor && digitsCount < digitsBeforeCursor) {
          newCursorPosition = i + 1;
          continue;
        }
      }

      if (/\d/.test(formatted[i])) {
        digitsCount++;
        if (digitsCount >= digitsBeforeCursor) {
          newCursorPosition = i + 1;
          break;
        }
      }
    }

    // If we didn't find enough digits, place at end
    if (newCursorPosition === 0 || digitsCount < digitsBeforeCursor) {
      newCursorPosition = formatted.length;
    }

    // Restore cursor position
    input.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  formatJumpTimePart(digits) {
    // Remove any non-digits
    digits = digits.replace(/\D/g, '');

    if (digits.length === 0) {
      return '';
    }

    if (digits.length === 1) {
      return digits;
    } else if (digits.length === 2) {
      return digits;
    } else if (digits.length === 3) {
      // ABC -> AB:C
      return digits.substring(0, 2) + ':' + digits.substring(2);
    } else {
      // ABCD+ -> AB:CD
      return digits.substring(0, 2) + ':' + digits.substring(2, 4);
    }
  }

  handleJumpToTime() {
    const input = $("#jump-to-time-input");
    const timeString = input.val().trim();

    if (!timeString) {
      return;
    }

    // Parse the time using parseMatchTime method
    const parsedTime = this.parseMatchTime(timeString);

    if (parsedTime === null) {
      this.showJumpToTimeError("Formato inválido. Use MM:SS ou MM:SS+MM:SS");
      this.highlightInputError(input);
      return;
    }

    // Convert match time to absolute video time
    const absoluteTime = this.convertMatchTimeToAbsolute(parsedTime);

    // Validate if time is within video bounds
    const videoDuration = this.player.duration();

    if (absoluteTime < 0 || absoluteTime > videoDuration) {
      this.showJumpToTimeError(`Tempo fora do vídeo (0 a ${this.formatTimeMMSS(videoDuration)})`);
      this.highlightInputError(input);
      return;
    }

    // Jump to the time
    this.jumpToAbsoluteTime(absoluteTime);

    // Clear input and remove error visual feedback
    this.clearJumpToTimeInput();
  }

  parseMatchTime(timeString) {
    // Remove extra spaces
    timeString = timeString.trim();

    // Regex for MM:SS or MM:SS+MM:SS
    const simplePattern = /^(\d{1,2}):(\d{2})$/; // Ex: 35:30
    const overtimePattern = /^(\d{1,2}):(\d{2})\+(\d{1,2}):(\d{2})$/; // Ex: 45:00+03:00

    let match;

    // Try overtime format first
    match = timeString.match(overtimePattern);
    if (match) {
      const mainMinutes = parseInt(match[1], 10);
      const mainSeconds = parseInt(match[2], 10);
      const additionalMinutes = parseInt(match[3], 10);
      const additionalSeconds = parseInt(match[4], 10);

      // Validate values
      if (mainSeconds >= 60 || additionalSeconds >= 60) {
        return null;
      }

      return {
        mainMinutes: mainMinutes,
        mainSeconds: mainSeconds,
        additionalMinutes: additionalMinutes,
        additionalSeconds: additionalSeconds,
        hasAdditional: true
      };
    }

    // Try simple format
    match = timeString.match(simplePattern);
    if (match) {
      const minutes = parseInt(match[1], 10);
      const seconds = parseInt(match[2], 10);

      // Validate values
      if (seconds >= 60) {
        return null;
      }

      return {
        mainMinutes: minutes,
        mainSeconds: seconds,
        additionalMinutes: 0,
        additionalSeconds: 0,
        hasAdditional: false
      };
    }

    // Invalid format
    return null;
  }

  convertMatchTimeToAbsolute(parsedTime) {
    // IMPORTANT: This logic is the REVERSE of what gamevideojs does
    // gamevideojs converts: absolute time → match time
    // Here we need: match time → absolute time

    const firstMatchStartTime = parseFloat($('#appointment-player').data('first-match-start-time')) || 0;
    const secondMatchStartTime = parseFloat($('#appointment-player').data('second-match-start-time')) || 0;

    // Calculate total seconds for main time and additional time
    const mainTimeSeconds = parsedTime.mainMinutes * 60 + parsedTime.mainSeconds;
    const additionalTimeSeconds = parsedTime.additionalMinutes * 60 + parsedTime.additionalSeconds;

    // If no match time data, assume input IS absolute time
    if (firstMatchStartTime === 0 && secondMatchStartTime === 0) {
      return mainTimeSeconds + additionalTimeSeconds;
    }

    // Conversion logic based on main time minutes:
    // If mainMinutes <= 45 → first half (including first half injury time)
    // If mainMinutes > 45 → second half

    const FIRST_HALF_MINUTES = 45;

    let absoluteTime;

    if (parsedTime.mainMinutes <= FIRST_HALF_MINUTES) {
      // First half (including first half injury time)
      // Formula: firstMatchStartTime + mainTime + additionalTime
      absoluteTime = firstMatchStartTime + mainTimeSeconds + additionalTimeSeconds;
    } else {
      // Second half
      // Formula: secondMatchStartTime + (mainTime - 45:00) + additionalTime
      const secondHalfTime = mainTimeSeconds - (FIRST_HALF_MINUTES * 60);
      absoluteTime = secondMatchStartTime + secondHalfTime + additionalTimeSeconds;
    }

    return absoluteTime;
  }

  jumpToAbsoluteTime(absoluteTime) {
    // If crop is applied, need to check if target is within viewport
    let targetTime = absoluteTime;

    if (this.cropApplied && this.viewportStart) {
      // Check if time is within crop viewport
      if (absoluteTime < this.viewportStart || absoluteTime > this.viewportEnd) {
        // Remove crop to allow jump
        this.removeCropFromTimeline();
      } else {
        // Convert to relative time within crop
        targetTime = absoluteTime - this.viewportStart;
      }
    }

    // Pause video before jumping (recommended)
    this.player.pause();

    // Jump to time
    this.player.currentTime(targetTime);

    // Auto-play (optional, but recommended)
    setTimeout(() => {
      this.player.play();
    }, 100);

    // Visual feedback (optional)
    this.showJumpToTimeSuccess();
  }

  showJumpToTimeError(message) {

    // Show temporary error message below input
    const errorMsg = $('<small class="text-danger jump-to-time-error d-block mt-1"></small>').text(message);
    $('#jump-to-time-input').parent().after(errorMsg);

    setTimeout(() => {
      errorMsg.fadeOut(() => errorMsg.remove());
    }, 3000);
  }

  showJumpToTimeSuccess() {
    // Visual feedback on success
    const input = $('#jump-to-time-input');

    // Green flash
    input.addClass('border-success');
    setTimeout(() => {
      input.removeClass('border-success');
    }, 500);
  }

  highlightInputError(input) {
    // Highlight input with red border
    input.addClass('border-danger');

    setTimeout(() => {
      input.removeClass('border-danger');
    }, 2000);
  }

  clearJumpToTimeInput() {
    const input = $('#jump-to-time-input');
    input.val('');
    input.removeClass('border-danger border-success');
    $('.jump-to-time-error').remove();
  }

  formatTimeMMSS(seconds) {
    // Format seconds to MM:SS
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

}
